import React from 'react';

import { trans } from '@spotahome/soyuz/client';
import { Heading } from '@spotahome/ui-library';

import './LookingForYou.scss';

const LookingForYou = () => (
  <div className="wrapper">
    <Heading
      size="large"
      text={trans('ambassador.looking_for_you.title')}
      className="mb-xl"
    />

    <p className="looking-for-you__description">
      {trans('ambassador.looking_for_you.description')}
    </p>

    <div className="two-cols looking-for-you__conditions  mb-xl">
      <div>
        <Heading
          text={trans('ambassador.looking_for_you.conditions.first.title')}
          type="capitalize"
          level={3}
          className="looking-for-you__conditions-title mb-m"
        />
        <p>{trans('ambassador.looking_for_you.conditions.first.content')}</p>
      </div>
      <div>
        <Heading
          text={trans('ambassador.looking_for_you.conditions.second.title')}
          type="capitalize"
          level={3}
          className="looking-for-you__conditions-title mb-m"
        />
        <p>{trans('ambassador.looking_for_you.conditions.second.content')}</p>
      </div>
    </div>

    <p className="looking-for-you__claim">
      {trans('ambassador.looking_for_you.claim')}
    </p>
  </div>
);

export default LookingForYou;
